import { render, staticRenderFns } from "./ProductsControl.vue?vue&type=template&id=6f95efe0&"
import script from "./ProductsControl.vue?vue&type=script&lang=js&"
export * from "./ProductsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports